import SVG from 'react-inlinesvg';
import './avatar-style.scss';

type Props = {
  src?: string;
  size?: number;
  title?: string;
  alt?: string;
};

const Avatar = ({ src, size, title, alt = 'Photo' }: Props) => {

  return (
    <div className="user-avatar-container" style={size ? { width: size, height: size } : undefined}>
      {src
        ? <img src={src} alt={alt} className="avatar-icon" {...title ? { title: title } : {}} />
        : <SVG cacheRequests={true} className="avatar-icon" src={`/svg/user-icon.svg`} title={alt} />
      }
    </div>
  );
};

export default Avatar;
